module.exports = __webpack_public_path__ + "img/IMG_3235.803522d1.jpg";